import { useCallback, useEffect, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function Row({ c, edit, onSaved }) {
  const [name, setName] = useState(c.name);
  const save = async (patch) => {
    try { await api.put(`/insaat/categories/${c.id}`, { name, is_active: c.is_active, sort: c.sort, ...patch }); onSaved(); } catch (e) { toast.error(apiError(e)); }
  };
  const del = async () => {
    if (!window.confirm(`${c.name} silinsin mi?`)) return;
    try { await api.delete(`/insaat/categories/${c.id}`); onSaved(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <tr data-testid={`category-row-${c.id}`}>
      <td className="font-mono text-xs text-slate-400">{c.sort}</td>
      <td>{edit ? <Input className="h-8 max-w-xs" value={name} onChange={(e) => setName(e.target.value)} data-testid={`category-name-${c.id}`} /> : c.name}</td>
      <td><Switch checked={c.is_active} disabled={!edit} onCheckedChange={(v) => save({ is_active: v })} data-testid={`category-active-${c.id}`} /><span className="ml-2 text-xs text-slate-500">{c.is_active ? "Aktif" : "Pasif"}</span></td>
      <td className="text-right text-xs">{c.usage_count}</td>
      <td className="text-right whitespace-nowrap">{edit && <>
        {name.trim() !== c.name && <Button size="sm" variant="outline" className="h-7" onClick={() => save({})} data-testid={`category-save-${c.id}`}><Save className="h-3.5 w-3.5 mr-1" />Kaydet</Button>}
        {c.usage_count === 0 && <Button size="icon" variant="ghost" className="h-7 w-7 text-rose-600" onClick={del} data-testid={`category-delete-${c.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>}</>}</td>
    </tr>
  );
}

export default function ConstructionCategoriesTab() {
  const { can } = useAuth();
  const edit = can("ayarlar", "edit");
  const [items, setItems] = useState(null);
  const [name, setName] = useState("");
  const load = useCallback(() => api.get("/insaat/categories", { params: { include_passive: true } }).then(({ data }) => setItems(data.items)).catch((e) => toast.error(apiError(e))), []);
  useEffect(() => { load(); }, [load]);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/insaat/categories", { name: name.trim() }); setName(""); load(); toast.success("Gider kalemi eklendi"); } catch (er) { toast.error(apiError(er)); }
  };
  return (
    <div className="panel overflow-hidden max-w-3xl" data-testid="construction-categories-tab">
      <div className="p-3 border-b border-slate-200 text-[13px] text-slate-600">Pasif kalemler yeni gider ekranında görünmez; eski kayıtlarda korunur. Kullanılan kalem silinemez.</div>
      {edit && <form onSubmit={add} className="flex gap-2 p-3 border-b border-slate-200">
        <Input className="h-9 max-w-xs" placeholder="Yeni gider kalemi" value={name} onChange={(e) => setName(e.target.value)} maxLength={80} data-testid="category-new-input" />
        <Button type="submit" size="sm" className="h-9 bg-blue-600 hover:bg-blue-700" disabled={name.trim().length < 2} data-testid="category-new-button"><Plus className="h-4 w-4 mr-1" />Ekle</Button></form>}
      <table className="erp-table" data-testid="category-table">
        <thead><tr><th>#</th><th>Gider Kalemi</th><th>Durum</th><th className="text-right">Kullanım</th><th /></tr></thead>
        <tbody>{(items || []).map((c) => <Row key={`${c.id}-${c.name}-${c.is_active}`} c={c} edit={edit} onSaved={load} />)}</tbody>
      </table>
    </div>
  );
}
